<template>
    <div class="collapse-icon accordion-icon-rotate left">
        <div id="appointmentFormCollapse" class="card-header">
            <a data-toggle="collapse" href="#collapseAppointmentForm" class="lead">{{ $t("labels.newAppointment") }}</a>
        </div>
        <div id="collapseAppointmentForm" class="collapse hide">
            <appointment-form :appointment="appointment" v-on:saveappointment="saveAppointment"></appointment-form>
        </div>
        <div id="appointmentCalendar">
            <div class="row">
                <div class="col-md-12">
                    <calendar-view
                        :show-date="showDate"
                        :events="calendarAppointments"
                        v-on:click-event="editAppointment"
                        v-on:click-date="newAppointment"
                        class="theme-default holiday-us-traditional holiday-us-official">
                        <calendar-view-header
                            slot="header"
                            slot-scope="t"
                            :header-props="t.headerProps"
                            @input="setShowDate"
                        />
                    </calendar-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppointmentForm from './AppointmentForm'
import AppointmentService from '@/services/appointment'
import CalendarView from "../shared/vue-simple-calendar/CalendarView.vue"
import CalendarViewHeader from "../shared/vue-simple-calendar/CalendarViewHeader.vue"
import moment from 'moment'

export default {
    props: ["patient"],
    components: {
        AppointmentForm,
        CalendarView,
        CalendarViewHeader
    },
    data() {
        return {
            errors: [],
            showDate: new Date(),
            calendarAppointments: [],
            appointments: [],
            appointment: {
                date: '',
                title: '',
                location: '',
                notifyBy: '',
                notifyWhen: ''
            }
        }
    },
    methods: {
        newAppointment(date) {
            this.$emit('newappointment',date)
        },
        saveAppointment: async function() {
            this.errors = []
            if (!this.appointment.date) {
                this.errors.push(this.$t("errors.dateRequired"))
            }
            //if (this.appointment.type.length === 0) {
            //    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.type")]))
            //}
            if (this.appointment.description.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.description")]))
            }
            //if (this.appointment.location.length === 0) {
            //    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.location")]))
            //}
            //if (this.appointment.notifyBy.length === 0) {
            //    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.notifyBy")]))
            //}
            //if (this.appointment.notifyWhen.length === 0) {
            //    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.notifyWhen")]))
            //}
            if (this.errors.length === 0) {
                this.appointment.patientId = this.patient._id
                let result = await AppointmentService.create(this.appointment)
                if (result) {
                    this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.appointment")]))
                    this.appointment = {}
                    await this.getAppointments()
                } else {
                    this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                }
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
            }
        },
        editAppointment(current) {
            let appointment = this.appointments.find(appointment => appointment._id === current.id)
            this.$store.state.currentAppointment = appointment
            this.$emit('appointmentmodal')
        },
        setShowDate(d) {
            this.showDate = d
        },
        getAppointments: async function() {
            let appointments = await AppointmentService.all(this.patient._id)
            this.appointments = appointments.data
            let appointmentlist = []
            for (let item in this.appointments) {
                let current = this.appointments[item]
                let appointment = {}
                appointment.id = current._id
                appointment.title = `${current.location} - ${moment(current.date).format('HH:mm')}`
                appointment.startDate = moment(current.date).format('YYYY-MM-DD HH:MM:SS')
                appointmentlist.push(appointment)
            }
            this.calendarAppointments = appointmentlist
        }
    },
    mounted: async function() {
        await this.getAppointments()
    }
}
</script>

